module.exports = __webpack_public_path__ + "img/project19_2.png.4e2a0e08.webp";